export default [
  {
    path: '/',
    name: 'app-root',
    component: () => import('@/pages/auth/login'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
      roles: ["user", "anonymous"]
    },
  },
  {
    path: '/auth/confirm-email',
    name: 'auth-confirm-email',
    component: () => import('@/pages/auth/confirm-email'),
    meta: {
      layout: 'full',
      roles: ["user", "anonymous"]
    },
  },
  {
    path: '/auth/login',
    name: 'auth-login',
    component: () => import('@/pages/auth/login'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
      roles: ["user", "anonymous"]
    },
  },
  {
    path: '/auth/register',
    name: 'auth-register',
    component: () => import('@/pages/auth/register'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
      roles: ["user", "anonymous"]
    },
  },
  {
    path: '/auth/register/closed',
    name: 'auth-no-sign_ups',
    component: () => import('@/pages/auth/registration-closed'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
      roles: ["user", "anonymous"],
    },
  },
  {
    path: '/auth/register/success',
    name: 'auth-register-success',
    component: () => import('@/pages/auth/register-success'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
      roles: ["user", "anonymous"]
    },
  },
  {
    path: '/auth/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/pages/auth/forgot-password'),
    meta: {
      layout: 'full',
      redirectIfLoggedIn: true,
      roles: ["user", "anonymous"]
    },
  },
  {
    path: '/auth/forgot-password-mfa',
    name: 'auth-forgot-password-mfa',
    component: () => import('@/pages/auth/forgot-password/mfa-password-reset'),
    meta: {
      layout: 'full',
      // Allow access even if logged in to complete MFA password reset
      redirectIfLoggedIn: false,
      roles: ["user", "anonymous"]
    },
  },
  {
    path: '/auth/reset-password',
    name: 'auth-reset-password',
    component: () => import('@/pages/auth/reset-password'),
    meta: {
      layout: 'full',
      // Allow access even if logged in to complete password reset
      redirectIfLoggedIn: false,
      roles: ["user", "anonymous"]
    },
  },
  {
    path: '/auth/verify-phone',
    name: 'auth-verify-phone',
    component: () => import('@/pages/auth/verify-phone'),
    meta: {
      layout: 'full',
      roles: ["user"],
      logPageName: "View Verify Phone Page",
    },
  },
  {
    path: '/auth/onboard',
    name: 'onboarding',
    component: () => import('@/pages/auth/onboarding'),
    meta: {
      layout: 'full',
      roles: ["user"],
      requireAuth: true,
      logPageName: "Onboarding",
    },
  },
  {
    path: '/auth/account',
    name: 'auth-update-profile-account',
    component: () => import('@/pages/auth/profile'),
    meta: {
      roles: ["user"],
      requireAuth: true,
      logPageName: "View Profile Page",
    },
  },
  {
    path: '/auth/member-profile',
    name: 'member-profile-edit',
    component: () => import('@/pages/auth/profile/member.vue'),
    meta: {
      roles: ["user"],
      requireAuth: true,
      logPageName: "View Profile Page",
    },
  },
  {
    path: '/auth/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/pages/auth/error-403'),
    meta: {
      layout: 'full',
      roles: ["user"]
    },
  },
  {
    path: '/auth/maintenance-mode',
    name: 'misc-under-maintenance',
    component: () => import('@/pages/auth/maintenance'),
    meta: {
      layout: 'full',
      roles: ["user"],
      redirectIfLoggedIn: true
    },
  },

  //  Security routes
  {
    path: '/security/mfa',
    name: 'security-mfa',
    component: () => import('@/pages/auth/security/mfa'),
    meta: {
      roles: 'user',
      layout: 'full',
      requireAuth: true,
    },
  },
  {
    path: '/security/mfa-authentication',
    name: 'security-mfa-authentication',
    component: () => import('@/pages/auth/security/authentication'),
    meta: {
      roles: 'user',
      layout: 'full',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/security/mfa-activation',
    name: 'security-mfa-activation',
    component: () => import('@/pages/auth/security/activation'),
    meta: {
      roles: 'user',
      layout: 'full',
    },
  },
  {
    path: '/security/authentication-app',
    name: 'security-authentication-app',
    component: () => import('@/pages/auth/security/authentication-app'),
    meta: {
      roles: 'user',
      layout: 'full',
    },
  },
  {
    path: '/security/activation-app',
    name: 'security-activation-app',
    component: () => import('@/pages/auth/security/activation-app'),
    meta: {
      roles: 'user',
      layout: 'full',
    },
  },
  {
    path: '/security/password/expiry',
    name: 'security-password-expiry',
    component: () => import('@/pages/auth/password-expiration'),
    meta: {
      roles: "user",
      layout: 'full',
      requireAuth: true,
    },
  },
  {
    path: '/security/password/change',
    name: 'security-password-change',
    component: () => import('@/pages/auth/change-password'),
    meta: {
      roles: "user",
      layout: 'full',
      requireAuth: true,
    },
  },
]
